"use strict";

// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://office.visualstudio.com/GSX/_git/AugmentationLoop?path=%2Fmodules%2Ftypes-core%2Fsrc%2Ftiles.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridNeighborhoodContext = exports.GridCell = exports.Document = exports.Session = exports.TileGroup = exports.Binary = exports.Blob = void 0;
var schema_object_g_1 = require("./schema-object.g");
var Blob = /** @class */function () {
  function Blob(obj) {
    schema_object_g_1.SchemaObject.assign(Blob, this, obj);
  }
  Blob.getTypeName = function () {
    return 'AugLoop_Core_Blob';
  };
  Blob.getBaseTypes = function () {
    return [];
  };
  Blob.H_ = {
    T_: Blob.getTypeName(),
    B_: Blob.getBaseTypes()
  };
  return Blob;
}();
exports.Blob = Blob;
var Binary = /** @class */function () {
  function Binary(obj) {
    schema_object_g_1.SchemaObject.assign(Binary, this, obj);
  }
  Binary.getTypeName = function () {
    return 'AugLoop_Core_Binary';
  };
  Binary.getBaseTypes = function () {
    return [];
  };
  Binary.H_ = {
    T_: Binary.getTypeName(),
    B_: Binary.getBaseTypes()
  };
  return Binary;
}();
exports.Binary = Binary;
var TileGroup = /** @class */function () {
  function TileGroup(obj) {
    schema_object_g_1.SchemaObject.assign(TileGroup, this, obj);
  }
  TileGroup.getTypeName = function () {
    return 'AugLoop_Core_TileGroup';
  };
  TileGroup.getBaseTypes = function () {
    return [];
  };
  TileGroup.H_ = {
    T_: TileGroup.getTypeName(),
    B_: TileGroup.getBaseTypes()
  };
  return TileGroup;
}();
exports.TileGroup = TileGroup;
var Session = /** @class */function () {
  function Session(obj) {
    schema_object_g_1.SchemaObject.assign(Session, this, obj);
  }
  Session.getTypeName = function () {
    return 'AugLoop_Core_Session';
  };
  Session.getBaseTypes = function () {
    return ['AugLoop_Core_TileGroup'];
  };
  Session.H_ = {
    T_: Session.getTypeName(),
    B_: Session.getBaseTypes()
  };
  return Session;
}();
exports.Session = Session;
var Document = /** @class */function () {
  function Document(obj) {
    schema_object_g_1.SchemaObject.assign(Document, this, obj);
  }
  Document.getTypeName = function () {
    return 'AugLoop_Core_Document';
  };
  Document.getBaseTypes = function () {
    return ['AugLoop_Core_TileGroup'];
  };
  Document.H_ = {
    T_: Document.getTypeName(),
    B_: Document.getBaseTypes()
  };
  return Document;
}();
exports.Document = Document;
var GridCell = /** @class */function () {
  function GridCell(obj) {
    schema_object_g_1.SchemaObject.assign(GridCell, this, obj);
  }
  GridCell.getTypeName = function () {
    return 'AugLoop_Core_GridCell';
  };
  GridCell.getBaseTypes = function () {
    return [];
  };
  GridCell.H_ = {
    T_: GridCell.getTypeName(),
    B_: GridCell.getBaseTypes()
  };
  return GridCell;
}();
exports.GridCell = GridCell;
var GridNeighborhoodContext = /** @class */function () {
  function GridNeighborhoodContext(obj) {
    schema_object_g_1.SchemaObject.assign(GridNeighborhoodContext, this, obj);
  }
  GridNeighborhoodContext.getTypeName = function () {
    return 'AugLoop_Core_GridNeighborhoodContext';
  };
  GridNeighborhoodContext.getBaseTypes = function () {
    return [];
  };
  GridNeighborhoodContext.H_ = {
    T_: GridNeighborhoodContext.getTypeName(),
    B_: GridNeighborhoodContext.getBaseTypes()
  };
  return GridNeighborhoodContext;
}();
exports.GridNeighborhoodContext = GridNeighborhoodContext;